import { useRef, useEffect } from 'react';

const subscribers = new Set();

/**
 * Some UI elements may need to respond to speech synthesis being activated.
 * E.g. accordions must be expanded.
 *
 * This hook allows components to subscribe to (just before) the start of
 * speech synthesis and perform any DOM side-effects as required, before
 * actually starting polly.
 */
function usePollyIntegration(targetRef, onBeforePollyStarted) {
  const handleBeforePollyStarted = context => {
    const target = targetRef.current;
    if (context.type === "range") {
      if (!target) {
        return;
      }
      const willBeReadOutLoud = context.range.commonAncestorContainer.contains(target);
      if (!willBeReadOutLoud) {
        return;
      }
    }
    onBeforePollyStarted(context);
  };
  const stableCb = useRef(handleBeforePollyStarted);
  stableCb.current = handleBeforePollyStarted;
  useEffect(() => {
    subscribers.add(stableCb);
    return () => {
      subscribers.delete(stableCb);
    };
  }, []);
}
async function executeIntegrationCallbacks(context) {
  await Promise.all([...subscribers.values()].map(ref => ref.current?.(context)));
}

export { executeIntegrationCallbacks, usePollyIntegration };
//# sourceMappingURL=hook.integration.js.map
